export enum ReportType {
    AGGREGATE = 'AGGREGATE',
    AVERAGE = 'AVERAGE',
    RANKING = 'RANKING',
    COUNT = 'COUNT'
}
